import { render, staticRenderFns } from "./OS-images.vue?vue&type=template&id=3ef79da4&%3ApageData=pageData&"
import script from "./OS-images.vue?vue&type=script&lang=js&"
export * from "./OS-images.vue?vue&type=script&lang=js&"
import style0 from "../assets/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports